import Layout from "../Layout";
import Loader from "../Layout/loader";

import { useEffect, useState } from "react";
import axios from "axios";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
} from "chart.js";
import { Doughnut, Line } from "react-chartjs-2";
import { map, s } from "framer-motion/m";
import { formatDateTimeLocal, codigoEvento } from "../Utils/utils";
import { time } from "framer-motion";

ChartJS.register(ArcElement, Tooltip, Legend);
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title);
ChartJS.defaults.font.family = "Roboto, sans-serif";
ChartJS.defaults.font.size = 14;

function formatarDataGrafico(input) {
  // Divide em data e hora
  const [data, hora] = input.split(" ");
  const [ano, mes, dia] = data.split("/");

  // Monta no formato desejado
  return `${dia}/${mes} ${hora}h`;
}

function Dashboard() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);
  const [dataPieProdutos, setDataPieProdutos] = useState({});
  const [dataPieFormaPgto, setDataPieFormaPgto] = useState({});
  const [dataVendasHora, setDataVendasHora] = useState(null);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [total, setTotal] = useState(0);

  const [displayDetalhesVendasHoras, setDisplayDetalhesVendasHoras] =
    useState(false);
  const [displayDetalhesVendasProdutos, setDisplayDetalhesVendasProdutos] =
    useState(false);
  const [displayDetalhesVendasFormaPgto, setDisplayDetalhesVendasFormaPgto] =
    useState(false);

  const [mapFormasPgto, setMapFormasPgto] = useState(new Map());
  const [lastUpdate, setlastUpdate] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    carregarDados();
  };

  const carregarDados = () => {
    let dtIni = document.getElementById("data-inicio")?.value ?? null;
    let dtFim = document.getElementById("data-fim")?.value ?? null;
    // console.log(dtIni, dtFim);
    axios
      .get(`${process.env.REACT_APP_API_URL}/ResumoEvento`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
          datainicial: formatDateTimeLocal(dtIni),
          datafinal: formatDateTimeLocal(dtFim),
        },
      })
      .then((response) => {
        setData(response.data[0]);
        console.log(data);
        setIsLoading(false);

        let labelVendas = [];
        let valorVendas = [];
        let qtdeVendas = [];
        response.data[0].vendasHora.forEach((item) => {
          labelVendas.push(formatarDataGrafico(item.DATASTAT));
          valorVendas.push(item.TOTAL);
          qtdeVendas.push(item.QTDE);
        });

        setDataVendasHora({
          labels: labelVendas,
          datasets: [
            {
              label: "Valor Vendido",
              data: valorVendas,
              borderColor: "#0066CC",
              backgroundColor: "#0066CC",
              tension: 0.4,
              fill: true,
            },
            {
              label: "Unidades Vendidas",
              data: qtdeVendas,
              borderColor: "#008000",
              backgroundColor: "#008000",
              tension: 0.4,
              fill: true,
            },
          ],
        });

        let labelsProdutos = [];
        let valorProdutos = [];
        let valorOutros = 0;
        let indexAux = 0;
        response.data[0].vendasProdutos.forEach((item) => {
          if (item.CODIGO != "0") {
            if (indexAux < 10) {
              labelsProdutos.push(item.DESCRICAO);
              valorProdutos.push(Number(item.TOTAL));
            } else {
              valorOutros += Number(item.TOTAL);
            }
            indexAux++;
          }
        });
        if (valorOutros > 0) {
          labelsProdutos.push("Outros");
          valorProdutos.push(valorOutros);
        }

        setDataPieProdutos({
          labels: labelsProdutos,
          datasets: [
            {
              label: "Valor Vendido",
              data: valorProdutos,
              backgroundColor: [
                "#FF0000",
                "#FF7F00",
                "#FFFF00",
                "#A0FF00",
                "#00CC00",
                "#008000",
                "#00CCCC",
                "#0066CC",
                "#0000CC",
                "#7F00FF",
                "#808080",
              ],

              borderWidth: 1,
            },
          ],
        });

        let mapFormasPgto = new Map();
        var totalPgtos = 0;
        response.data[0].vendasFormaPgto.forEach((item) => {
          mapFormasPgto.set(item.CODIGO, item.TOTAL);
          totalPgtos = totalPgtos + Number(item.TOTAL);
        });

        setTotal(totalPgtos - (mapFormasPgto.get(4) || 0));

        setMapFormasPgto(mapFormasPgto);

        setDataPieFormaPgto({
          labels: [
            "Dinheiro",
            "Pix Tef",
            "Pix",
            "Crédito",
            "Débito",
            "POS",
            "Voucher",
          ],
          datasets: [
            {
              label: "Valor Vendido",
              data: [
                mapFormasPgto.get(1) || 0,
                mapFormasPgto.get(8) || 0,
                mapFormasPgto.get(9) || 0,
                mapFormasPgto.get(6) || 0,
                mapFormasPgto.get(5) || 0,
                mapFormasPgto.get(2) || 0,
                mapFormasPgto.get(7) || 0,
              ],
              backgroundColor: [
                "#00CC00", // Dinheiro - verde médio forte
                "#FF7F00", // Pix Tef - laranja vibrante
                "#0066CC", // Pix - azul forte
                "#FFFF00", // Crédito - amarelo vivo
                "#7F00FF", // Débito - violeta intenso
                "#FF0000", // POS - vermelho clássico
                "#808080", // Voucher - cinza neutro
              ],

              borderWidth: 1,
            },
          ],
        });
        setlastUpdate(
          new Date().toLocaleString("pt-BR", {
            timeZone: "America/Sao_Paulo",
          })
        );
      })
      .catch((error) => {
        console.error("Erro na requisição:", error);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    carregarDados();
    setInterval(() => {
      carregarDados();
    }, 60000);
  }, []);

  return (
    <Layout>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="container mx-auto font-Roboto p-2">
          <div className="max-w-full mx-auto bg-white p-2">
            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-1 lg:grid-cols-3 items-end justify-center"
            >
              <div className="flex flex-col w-[90%]">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Data de Início
                </label>
                <input
                  id="data-inicio"
                  type="datetime-local"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="w-full font-Roboto border border-gray-400 text-base rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className="flex flex-col w-[90%]">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Data de Fim
                </label>
                <input
                  id="data-fim"
                  type="datetime-local"
                  min={startDate}
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="w-full font-Roboto border border-gray-400 text-base rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className="w-[90%] p-2 text-center">
                <span>Atualizado em: {lastUpdate}</span>
                <button
                  type="submit"
                  className="w-full flex justify-center gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                >
                  Enviar
                </button>
              </div>
            </form>
          </div>

          {total > 0 || mapFormasPgto.get(4) > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-6 gap-4 w-full">
              {total > 0 && (
                <>
                  <div className="col-span-1 md:col-span-6 border border-gray-300 rounded-lg shadow p-4 space-y-4">
                    <h1 className="font-Oswald text-center">
                      Total em Vendas :{" "}
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(total || 0)}
                    </h1>
                  </div>
                  {(Math.abs(data?.retref?.retirada) || 0) > 0 &&
                    (Math.abs(data?.retref?.reforco) || 0) > 0 && (
                      <>
                        <div className="col-span-3 border border-gray-300 rounded-lg shadow p-4 space-y-4">
                          <h1 className="font-Oswald text-center">
                            {new Intl.NumberFormat("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            }).format(Math.abs(data?.retref?.retirada) || 0)}
                          </h1>
                          <p className="text-center text-sm text-gray-500 font-Roboto">
                            Retirada
                          </p>
                        </div>
                        <div className="col-span-3 border border-gray-300 rounded-lg shadow p-4 space-y-4">
                          <h1 className="font-Oswald text-center">
                            {new Intl.NumberFormat("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            }).format(Math.abs(data?.retref?.reforco) || 0)}
                          </h1>
                          <p className="text-center text-sm text-gray-500 font-Roboto">
                            Reforço
                          </p>
                        </div>
                      </>
                    )}
                </>
              )}
              {((mapFormasPgto.get(4) || 0) > 0 || data.QTDE_CARTOES > 5) && (
                <>
                  <div
                    className={
                      total > 0
                        ? "col-span-1 border border-gray-300 rounded-lg shadow p-4 space-y-4"
                        : "col-span-2 border border-gray-300 rounded-lg shadow p-4 space-y-4"
                    }
                  >
                    <h1 className="font-Oswald text-center">
                      {data.QTDE_CARTOES}
                    </h1>
                    <p className="text-center text-sm text-gray-500 font-Roboto">
                      Cartões Utilizados
                    </p>
                  </div>
                  {total > 0 && (
                    <div className="col-span-1 border border-gray-300 rounded-lg shadow p-4 space-y-4">
                      <h1 className="font-Oswald text-center">
                        {new Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }).format(total / data.QTDE_CARTOES || 0)}
                      </h1>
                      <p className="text-center text-sm text-gray-500 font-Roboto">
                        Ticket Médio
                      </p>
                    </div>
                  )}

                  <div
                    className={
                      total > 0
                        ? "col-span-1 border border-gray-300 rounded-lg shadow p-4 space-y-4"
                        : "col-span-2 border border-gray-300 rounded-lg shadow p-4 space-y-4"
                    }
                  >
                    <h1 className="font-Oswald text-center">
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(mapFormasPgto.get(4) || 0)}
                    </h1>
                    <p className="text-center text-sm text-gray-500 font-Roboto">
                      Consumo Total
                    </p>
                  </div>
                  <div
                    className={
                      total > 0
                        ? "col-span-1 border border-gray-300 rounded-lg shadow p-4 space-y-4"
                        : "col-span-2 border border-gray-300 rounded-lg shadow p-4 space-y-4"
                    }
                  >
                    <h1 className="font-Oswald text-center">
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(mapFormasPgto.get(4) / data.QTDE_CARTOES || 0)}
                    </h1>
                    <p className="text-center text-sm text-gray-500 font-Roboto">
                      Consumo Médio
                    </p>
                  </div>

                  {total > 0 && (
                    <div className="col-span-1 border border-gray-300 rounded-lg shadow p-4 space-y-4">
                      <h1 className="font-Oswald text-center">
                        {new Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }).format(data.DEVOLUCOES || 0)}
                      </h1>
                      <p className="text-center text-sm text-gray-500 font-Roboto">
                        Devoluções
                      </p>
                    </div>
                  )}

                  {total > 0 && (
                    <div className="col-span-1 border border-gray-300 rounded-lg shadow p-4 space-y-4">
                      <h1 className="font-Oswald text-center">
                        {new Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }).format(
                          total -
                            ((Number(data.DEVOLUCOES) || 0) +
                              (Number(mapFormasPgto.get(4)) || 0))
                        )}
                      </h1>
                      <p className="text-center text-sm text-gray-500 font-Roboto">
                        Saldo Residual
                      </p>
                    </div>
                  )}
                </>
              )}

              <div className="col-span-1 md:col-span-6 border border-gray-300 rounded-lg shadow p-4 space-y-4">
                <div className="w-full h-96">
                  <Line
                    data={dataVendasHora}
                    options={{
                      responsive: true,
                      maintainAspectRatio: false, // Para permitir altura fixa
                      layout: {
                        padding: 10,
                      },
                      plugins: {
                        legend: {
                          position: "bottom",
                          display: true,
                        },
                        tooltip: {
                          mode: "index",
                          intersect: true,
                          callbacks: {
                            label: function (tooltipItem) {
                              const datasetLabel =
                                tooltipItem.dataset.label || "";
                              let value = tooltipItem.formattedValue;

                              if (datasetLabel === "Valor Vendido") {
                                value = new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(tooltipItem.raw);
                              }

                              return `${datasetLabel}: ${value}`;
                            },
                          },
                        },
                      },
                      animation: {
                        tension: {
                          duration: 500,
                          easing: "linear",
                          from: 0.05,
                          to: 0,
                          loop: false,
                        },
                      },
                      hover: {
                        mode: "nearest",
                        intersect: true,
                      },
                      scales: {
                        x: {
                          title: {
                            display: false,
                            text: "Data/Hora",
                          },
                        },
                        y: {
                          title: {
                            display: true,
                            text: "Vendas",
                          },
                          ticks: {
                            callback: function (value) {
                              return new Intl.NumberFormat("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              }).format(value);
                            },
                          },
                        },
                      },
                    }}
                  />
                </div>
                <div className="w-full rounded-md">
                  <button
                    onClick={() =>
                      setDisplayDetalhesVendasHoras(!displayDetalhesVendasHoras)
                    }
                    className="w-full text-left px-4 py-3 border-none focus:outline-none hover:bg-gray-200 hover:text-gray-800"
                  >
                    {displayDetalhesVendasHoras ? "−" : "+"} Ver Vendas por Hora
                  </button>
                </div>
                {/* Conteúdo do Accordion com Transição */}
                <div
                  className={`mt-4 text-sm text-gray-700 overflow-hidden transition-all duration-300 ease-in-out ${
                    displayDetalhesVendasHoras
                      ? "max-h-none opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="text-sm text-gray-700">
                    <div className="overflow-x-auto">
                      <table className="min-w-full table-auto">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="px-4 py-2 text-left">Horário</th>
                            <th className="px-4 py-2 text-right">Quantidade</th>
                            <th className="px-4 py-2 text-right">
                              Valor Total
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.vendasHora.map((row, index) => (
                            <tr
                              key={index}
                              className={
                                index % 2 === 0 ? "bg-white" : "bg-gray-50"
                              }
                            >
                              <td className="px-4 py-2">
                                {formatarDataGrafico(row.DATASTAT)}
                              </td>
                              <td className="px-4 py-2 text-right">
                                {row.QTDE}
                              </td>
                              <td className="px-4 py-2 text-right">
                                {new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(row.TOTAL)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={
                  total > 0
                    ? "col-span-1 md:col-span-3 border border-gray-300 rounded-lg shadow p-4 space-y-4 max-h-none"
                    : "col-span-2 md:col-span-6 border border-gray-300 rounded-lg shadow p-4 space-y-4 max-h-none"
                }
              >
                <div className="w-full h-96 ">
                  <Doughnut
                    data={dataPieProdutos}
                    options={{
                      plugins: {
                        legend: {
                          display: true,
                          position: "right",
                        },
                        tooltip: {
                          callbacks: {
                            label: function (context) {
                              let value = context.raw;

                              return new Intl.NumberFormat("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              }).format(value);
                            },
                          },
                        },
                      },
                      responsive: true,
                      maintainAspectRatio: false,
                    }}
                  />
                </div>

                <div className="w-full rounded-md">
                  <button
                    onClick={() =>
                      setDisplayDetalhesVendasProdutos(
                        !displayDetalhesVendasProdutos
                      )
                    }
                    className="w-full text-left px-4 py-3 border-none focus:outline-none hover:bg-gray-200 hover:text-gray-800"
                  >
                    {displayDetalhesVendasProdutos ? "−" : "+"}
                    Ver Vendas por Produto
                  </button>
                </div>
                {/* Conteúdo do Accordion com Transição */}
                <div
                  className={`mt-4 text-sm text-gray-700 overflow-hidden transition-all duration-300 ease-in-out ${
                    displayDetalhesVendasProdutos
                      ? "max-h-none opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="text-sm text-gray-700">
                    <div className="overflow-x-auto">
                      <table className="min-w-full table-auto">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="px-4 py-2 text-left">Produto</th>
                            <th className="px-4 py-2 text-right">Quantidade</th>
                            <th className="px-4 py-2 text-right">
                              Valor Total
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.vendasProdutos.map(
                            (row, index) =>
                              row.CODIGO !== 0 && ( // Condicional correta para renderizar as linhas
                                <tr
                                  key={index}
                                  className={
                                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                                  }
                                >
                                  <td className="px-4 py-2">
                                    {row.CODIGO} - {row.DESCRICAO}
                                  </td>
                                  <td className="px-4 py-2 text-right">
                                    {row.QTDE}
                                  </td>
                                  <td className="px-4 py-2 text-right">
                                    {new Intl.NumberFormat("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    }).format(row.TOTAL)}
                                  </td>
                                </tr>
                              )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {total > 0 && (
                <div className="col-span-1 md:col-span-3 border border-gray-300 rounded-lg shadow p-4 space-y-4 max-h-none">
                  <div className="w-full h-96 ">
                    <Doughnut
                      data={dataPieFormaPgto}
                      options={{
                        plugins: {
                          legend: {
                            display: true,
                            position: "right",
                          },
                          tooltip: {
                            callbacks: {
                              label: function (context) {
                                let value = context.raw;

                                return new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(value);
                              },
                            },
                          },
                        },

                        responsive: true,
                        maintainAspectRatio: false,
                      }}
                    />
                  </div>

                  <div className="w-full rounded-md">
                    <button
                      onClick={() =>
                        setDisplayDetalhesVendasFormaPgto(
                          !displayDetalhesVendasFormaPgto
                        )
                      }
                      className="w-full text-left px-4 py-3 border-none focus:outline-none hover:bg-gray-200 hover:text-gray-800"
                    >
                      {displayDetalhesVendasFormaPgto ? "−" : "+"}
                      Ver Vendas por Forma de Pagamento
                    </button>
                  </div>
                  {/* Conteúdo do Accordion com Transição */}
                  <div
                    className={`mt-4 text-sm text-gray-700 overflow-hidden transition-all duration-300 ease-in-out ${
                      displayDetalhesVendasFormaPgto
                        ? "max-h-none opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    <div className="text-sm text-gray-700">
                      <div className="overflow-x-auto">
                        <table className="min-w-full table-auto">
                          <tbody>
                            <tr className="bg-white">
                              <td className="px-4 py-2">Dinheiro</td>
                              <td className="px-4 py-2 text-right">
                                {new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(mapFormasPgto.get(1) || 0)}
                              </td>
                            </tr>
                            <tr className="bg-white">
                              <td className="px-4 py-2">Pix - TEF</td>
                              <td className="px-4 py-2 text-right">
                                {new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(mapFormasPgto.get(8) || 0)}
                              </td>
                            </tr>
                            <tr className="bg-white">
                              <td className="px-4 py-2">Pix</td>
                              <td className="px-4 py-2 text-right">
                                {new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(mapFormasPgto.get(9) || 0)}
                              </td>
                            </tr>
                            <tr className="bg-white">
                              <td className="px-4 py-2">Crédito</td>
                              <td className="px-4 py-2 text-right">
                                {new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(mapFormasPgto.get(6) || 0)}
                              </td>
                            </tr>
                            <tr className="bg-white">
                              <td className="px-4 py-2">Débito</td>
                              <td className="px-4 py-2 text-right">
                                {new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(mapFormasPgto.get(5) || 0)}
                              </td>
                            </tr>
                            <tr className="bg-white">
                              <td className="px-4 py-2">Cartão via POS</td>
                              <td className="px-4 py-2 text-right">
                                {new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(mapFormasPgto.get(2) || 0)}
                              </td>
                            </tr>
                            <tr className="bg-white">
                              <td className="px-4 py-2">Voucher</td>
                              <td className="px-4 py-2 text-right">
                                {new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(mapFormasPgto.get(7) || 0)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="flex justify-center items-center h-96">
              <h1 className="text-lg font-semibold text-gray-700">
                Nenhum dado encontrado para o período selecionado.
              </h1>
            </div>
          )}
        </div>
      )}
    </Layout>
  );
}

export default Dashboard;
